import {Pipe, PipeTransform} from '@angular/core';
import {Zone} from './zone';

@Pipe({
    name: 'zahZone',
    standalone: false
})
export class ZonePipe implements PipeTransform {
  transform(zoneId: string, zones: Array<Zone>): string {
    if (!zones) {
      return '';
    } else {
      const zoneWithId = zones.find(zone => zone.getId() === zoneId);
      return zoneWithId ? zoneWithId.getLabel() : 'Onbekend';
    }
  }
}
